import type { Copy } from '../../types.ts';
import { aiAgents } from './aiAgents.ts';
import { collab } from './collab.ts';
import { common } from './common.ts';
import { contact } from './contact.ts';
import { cta } from './cta.ts';
import { download } from './download.ts';
import { connectors } from './connectors.ts';
import { faq } from './faq.ts';
import { footer } from './footer.ts';
import { hero } from './hero.ts';
import { knowledge } from './knowledge.ts';
import { legalPage, legalSeo, legalUi } from './legal.ts';
import { modules } from './modules.ts';
import { pm } from './pm.ts';
import { pricing } from './pricing.ts';
import { security } from './security.ts';
import { socialProof } from './socialProof.ts';

/**
 * Bản tiếng Anh. Hình dạng bị ép bằng `: Copy` ngay tại đây — thiếu hay gõ sai một khoá là lỗi
 * biên dịch, không cần test parity và không cần review bằng mắt.
 *
 * Đây là chỗ DUY NHẤT của bản `en` khai kiểu: các file phần (`common`, `hero`, `pm`…) để trần,
 * vì mỗi phần chỉ phủ một mảnh của hình dạng.
 */
export const en: Copy = {
  ...common,

  // Spread LỒNG, không phải `...legal` trơn: `seo` và `page` là khoá LỒNG, nên spread nông sẽ
  // THAY THẾ cả `common.seo`/`common.page` (mất `home`) thay vì gộp vào.
  seo: { ...common.seo, ...legalSeo },
  page: { ...common.page, ...legalPage },
  legal: legalUi,
  hero,
  socialProof,
  modules,
  collab,
  pm,
  aiAgents,
  knowledge,
  connectors,
  security,
  pricing,
  faq,
  download,
  cta,
  contact,
  footer,
};
